// extracted by mini-css-extract-plugin
export default {"wrapper":"_247b997b","header":"_b007e957","body":"_c99a5918","mobileSeparatorContainer":"_aecf8b2","mobileSeparator":"_553fc9d5"};